export const OpenIdType = {
  AU: 1,
};

export type OpenIdType = ValueOf<typeof OpenIdType>;

export type OpenId = Readonly<{
  type: OpenIdType;
  is_registered: boolean;
}>;

const create = (args: Partial<OpenId> = {}): OpenId => ({
  type: 1,
  is_registered: false,
  ...args,
});

const isRegisteredAuId = (data: OpenId[]) => {
  return data.some((item) => {
    if (item.type === OpenIdType.AU) {
      return item.is_registered;
    }
    return false;
  });
};

export const OpenId = { isRegisteredAuId, create } as const;
